
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#333333",
        "d": "M597.69335911 512l224.12109427-224.1210935c26.36718725-26.36718725 26.36718725-59.32617188 0-85.69335988s-59.32617188-26.36718725-85.69335988 0L512 426.30664089 287.8789065 202.18554662c-26.36718725-26.36718725-59.32617188-26.36718725-85.69335988 0s-26.36718725 59.32617188 0 85.69335988L426.30664089 512 202.18554662 736.1210935c-26.36718725 26.36718725-26.36718725 59.32617188 0 85.69335988s59.32617188 26.36718725 85.69335988 0L512 597.69335911l224.1210935 224.12109427c26.36718725 26.36718725 59.32617188 26.36718725 85.69335988 0s26.36718725-59.32617188 0-85.69335988L597.69335911 512z"
      }
    }
  ]
})
    }
  